'use strict';

var _ = require('lodash');
var validator = require('../../validator');

var $form, $continue, $requiredInputs, checkoutformValidator;

var hasEmptyRequired = function () {
    // filter out only the visible fields
    var requiredValues = $requiredInputs.filter(':visible').map(function () {
        return $(this).val();
    });
    return _(requiredValues).includes('');
};

var validateForm = function () {
    // only validate form when all required fields are filled to avoid
    // throwing errors on empty form
	if($('.no-shipping-available').length > 0 ) {
		$("#primary .tax-error-message:visible").addClass('hide');        
	} else {
		if (!checkoutformValidator) {
	        return;
	    }
		var $parent = $("div.payment-method:visible, form.checkout-billing.address:visible, form.checkout-shipping.address:visible");
		var formateValidate = $parent.find(":input.required").hasClass("error");
	    $requiredInputs = $('.required', $form).find(':input');
	    if (!hasEmptyRequired() && !formateValidate) {
	            $("#primary .required-fields-warn:visible,#secondary .required-fields-warn:visible").addClass('hide');
	            $("#primary .required-shipping-warn:visible,#secondary .required-shipping-warn:visible").addClass('hide');
	    } 	
	}
};

var validateEl = function () {
	if($('.no-shipping-available').length > 0 ) {
		$("#primary .tax-error-message:visible").addClass('hide');
    } else {
		if ($(this).val() === '') {
	        return;
	    } else {
	        // only validate single field
	    	if($(this).is(":visible")) {
	    		if(($(this).hasClass('error') || $(this).closest('.form-row').hasClass('error-handle')) &&  $(this).is(":focus")){
	    			validator.settings.errorClear(this);
	    		}
	    		var $parent = $(this).closest("div.payment-method, form.checkout-billing.address, form.checkout-shipping.address");
	    		var formateValidate = $parent.find(":input.required:visible").hasClass("error");
	    		if (!hasEmptyRequired() && !formateValidate) {
	    			 $("#primary .required-fields-warn:visible,#secondary .required-fields-warn:visible").addClass('hide');
	    			 $("#primary .required-shipping-warn:visible,#secondary .required-shipping-warn:visible").addClass('hide');
		        }
	    	}
	    }	
	}
};
var completeFormMessage= function(){
	var $parent = $("div.payment-method, form.checkout-billing.address, form.checkout-shipping.address,form#checkoutCreateAccount");
	var formateValidate = $parent.find(":input.required:visible").hasClass("error");
	var formatServerValidate=$parent.find(":input.required:visible").closest('.form-row').hasClass('error-handle');
	if (hasEmptyRequired() || formateValidate || formatServerValidate ) {
    	if($('.no-shipping-available').length > 0 ) {
    		if ($("#primary .disabled-hover-event").closest('.ck-field-required-error-handle').find('.required-shipping-warn').length <= 0) {
    			$("#primary .disabled-hover-event").closest('.ck-field-required-error-handle').find('.tax-error-message').addClass('hide');
	    		$("#primary .disabled-hover-event").closest('.ck-field-required-error-handle').prepend('<div class="required-shipping-warn">'+Resources.CHECKOUT_AVALARA_TAX_ERROR+'</div>');
	    	}
	    	if ($("#secondary .disabled-hover-event").closest('div').find('.required-shipping-warn').length <= 0) {
	    		$("#secondary .disabled-hover-event").closest('div').prepend('<div class="required-shipping-warn">'+Resources.CHECKOUT_AVALARA_TAX_ERROR+'</div>');
			}
			if($("#primary .disabled-hover-event,#secondary .disabled-hover-event").closest('.ck-field-required-error-handle').find('.required-shipping-warn').hasClass('hide')){
				$('#primary .required-shipping-warn.hide,#secondary .required-shipping-warn.hide').removeClass('hide');	
			}
    	}else {
    		if ($("#primary .disabled-hover-event").closest('.ck-field-required-error-handle').find('.required-fields-warn').length <= 0) {
	    		$("#primary .disabled-hover-event").closest('.ck-field-required-error-handle').prepend('<div class="required-fields-warn">'+Resources.CHECKOUT_REQUIRED_CONTINUE+'</div>');
			}				
	    	if ($("#secondary .disabled-hover-event").closest('div').find('.required-fields-warn').length <= 0 ) {
	    		$("#secondary .disabled-hover-event").closest('div').prepend('<div class="required-fields-warn">'+Resources.CHECKOUT_REQUIRED_CONTINUE+'</div>');
			}
			if($("#primary .disabled-hover-event,#secondary .disabled-hover-event").closest('.ck-field-required-error-handle').find('.required-fields-warn').hasClass('hide')){
				$('#primary .required-fields-warn.hide,#secondary .required-fields-warn.hide').removeClass('hide');	
			}
    	}
    }
};

var init = function (opts) {
    if (!opts.formSelector || !opts.continueSelector) {
        throw new Error('Missing form and continue action selectors.');
    }
    $form = $(opts.formSelector);
    $continue = $(opts.continueSelector);
    checkoutformValidator = $form.validate(validator.settings);
    $requiredInputs = $('.required', $form).find(':input');
    validateForm();
    
    // start listening
	$requiredInputs.off('change input', validateEl).on('change input', validateEl);
    
    //SM-4681 special characters validation for address-2. 
    $('body').off('focusout','.address  .address2').on('focusout','.address .address2', function() {
        if(checkoutformValidator.element(this)) {
            return false;
        }
    });    
    
    
    //ValidateEl to remove error for address-2
    $('body').off('keyup change input','.address  .address2').on('keyup change input','.address .address2',validateEl);
    
    var spcExpCheckoutElement= $(window).width()<1024 ? ":not('.spc-summary-btn')" : " ";
    
    $(".order-summary-footer .rightbutton,.checkout-tabs .button-fancy-large"+spcExpCheckoutElement).off('mouseenter touchstart').on('mouseenter touchstart',function(e) {
    	completeFormMessage();    
	});
};

exports.init = init;
exports.validateForm = validateForm;
exports.validateEl = validateEl;
exports.completeFormMessage = completeFormMessage;
